import { Box, Typography } from "@mui/material";
import { useAuthStore } from "hooks/useAuthStore";

export const InfoUser = () => {
  const { user } = useAuthStore();
  return (
    <Box className="flex justify-center items-center flex-wrap">
      <Typography variant="h5" className="text-center w-full">
        {user.fullName}
      </Typography>
      <Typography className="text-center w-full pt-1">
        {user.emailAlternativo}
      </Typography>
    </Box>
  );
};
